import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { capitalize } from 'lodash';
import S from './styles';

export const update_profile = ({ employableType, workrooms,
                                 surfaceTypes, event: { data } }) => {
  const updates = data.updates;

  const eventKeys = Object.keys(updates);

  const formatKey = (key) => {
    const keyArr = key.split('_');
    const capitalizedKeyArr = keyArr.map(el => capitalize(el));
    return capitalizedKeyArr.join(' ');
  };

  const isPopulated = (arr = null) => arr && Array.isArray(arr) && arr.length > 0;

  const formatList = (arr = [], key) => {
    let returnList = [];
    switch (key) {
      case 'workrooms':
        returnList = isPopulated(workrooms) && isPopulated(arr) ?
          workrooms.filter(wrkm => arr.includes(wrkm.id))
                                      .map(wrkm => `'${wrkm.name}'`) : null;
        break;
      case 'surface_types':
        returnList = isPopulated(surfaceTypes) && isPopulated(arr) ?
          surfaceTypes.filter(st => arr.includes(st.id))
                                       .map(st => `'${st.name}'`) : null;
        break;
      case 'covered_zip_codes':
        returnList = isPopulated(arr) ? arr.map(zip => ` ${zip}`) : null;
        break;
      default:
        returnList = null;
    }
    return isPopulated(returnList) ?
      returnList.join(', ') : 'N/A';
  };

  // const formatStd = (item) => {
  //   let itemCopy = item;
  //   if (itemCopy == null || !itemCopy) itemCopy = 'N/A';
  //   if (typeof itemCopy === 'boolean') itemCopy = itemCopy.toString();
  //   return (Array.isArray(itemCopy) ? itemCopy.map(i =>
  //     capitalize(i)).join(', ') : capitalize(itemCopy));
  // };

  const formatStd = (item) => {
    let itemCopy = item;
    if (itemCopy == null || !itemCopy) return 'N/A';
    if (isPopulated(itemCopy)) return itemCopy.map(i => capitalize(i)).join(', ');
    else if (Array.isArray(itemCopy)) return 'N/A';
    else if (typeof itemCopy === 'boolean') itemCopy = itemCopy.toString();
    return typeof itemCopy === 'string' ? capitalize(itemCopy) : 'N/A';
  };

  const getKeys = obj => Object.keys(obj);

  const nestedProperties = key => Object.keys(data.updates[key]).map(nKey => nKey);

  const renderEmployee = () => {
    const nestedAttributes = ['badge', 'manage_vendor_workrooms'];
    return (<ul className={S.updatesList}>
      {eventKeys.map((key, ind) => (<Fragment key={`${updates[key] + ind}`}>
        {nestedAttributes.includes(key) ? (<Fragment>
          {nestedProperties(key).map((nKey) => {
            const oldVal = updates[key][nKey][0];
            const newVal = updates[key][nKey][1];
            const displayOld = typeof oldVal === 'boolean' ? oldVal.toString() : oldVal || 'N/A';
            const displayNew = typeof newVal === 'boolean' ? newVal.toString() : newVal || 'N/A';
            return (<li key={`${updates[key][nKey] + ind}`}>
              {`${formatKey(key)} ${formatKey(nKey)}: "${displayOld}" changed to "${displayNew}"`}
            </li>);
          })}
        </Fragment>) : (<li>
          {['workrooms', 'covered_zip_codes'].includes(key)
            ? `${formatKey(key)}: "${formatList(updates[key][0], key)}" changed to "${formatList(updates[key][1], key)}"`
            : `${formatKey(key)}: "${formatStd(updates[key][0])}" changed to "${formatStd(updates[key][1])}"`}
        </li>)}
      </Fragment>))}
    </ul>);
  };

  const renderInstaller = () => {
    const updatesOrder = ['installer', 'crew', 'helper'].filter(key => eventKeys.includes(key));
    return (<ul className={S.updatesList}>{updatesOrder.map((ent, idx1) =>
      <Fragment key={`${updates[ent] + idx1}`}>{['crew', 'helper'].includes(ent) ?
        <Fragment>{getKeys(updates[ent]).map((name, idx2) => (
          <Fragment key={`${updates[ent][name] + idx2}`}>
            <li>{`${getKeys(updates[ent])[idx2]} (${capitalize(ent)}):`}</li>
            <ul>{getKeys(updates[ent][name]).map((attr, idx3) => (
              <li key={`${updates[ent][name][attr] + idx3}`} className={S.nestedAttribute}>
                {['workrooms', 'surface_types', 'covered_zip_codes'].includes(attr) ?
                  `${formatKey(getKeys(updates[ent][name])[idx3])}: Changed from "${formatList(updates[ent][name][attr][0], attr)}" to "${formatList(updates[ent][name][attr][1], attr)}"` :
                  `${formatKey(getKeys(updates[ent][name])[idx3])}: Changed from "${updates[ent][name][attr][0] || 'N/A'}" to "${updates[ent][name][attr][1] || 'N/A'}"`}
              </li>
            ))}</ul>
          </Fragment>
        ))}</Fragment> :
        <Fragment> {getKeys(updates[ent]).map((attr, idx) => (
          <li key={`${updates[ent] + idx}`}>{`${formatKey(attr)}: Changed from "${updates[ent][attr][0]}" to "${updates[ent][attr][1]}"`}</li>))}
        </Fragment>}
      </Fragment>,
    )}
    </ul>);
  };

  return (<Fragment>
    {employableType === 'installer' && renderInstaller()}
    {['employee', 'estimator'].includes(employableType) && renderEmployee()}
  </Fragment>);
};

update_profile.propTypes = {
  event: PropTypes.shape({
    data: PropTypes.shape({
      note: PropTypes.string,
      updates: PropTypes.obj,
    }).isRequired,
  }).isRequired,
  workrooms: PropTypes.array,
  surfaceTypes: PropTypes.array,
  employableType: PropTypes.string,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/EmployableHistory/EmployableHistoryCard/employableEvents/update_profile.jsx